import { useState } from 'react'

import { AgentComposer, type AgentComposerFile } from '@/components/ui/agent-composer'
import { CopyButton } from '@/components/ui/CopyButton'
import { Demo, DsSection } from '../primitives'

const FILES: AgentComposerFile[] = [
  { key: 'settlement', name: 'acme-settlement-week-42.pdf', detail: '2 pages', onRemove: () => {} },
  { key: 'roster', name: 'fleet-roster.xlsx', uploading: true },
]

const noop = () => {}

const STATES: { prop: string; composer: React.ReactNode }[] = [
  {
    prop: 'files={files}',
    composer: (
      <AgentComposer
        value="What did we spend on fuel last week?"
        onValueChange={noop}
        onSend={noop}
        files={FILES}
      />
    ),
  },
  {
    prop: 'dragging',
    composer: <AgentComposer value="" onValueChange={noop} onSend={noop} onAttach={noop} dragging />,
  },
  {
    prop: 'onStop={stop}',
    composer: <AgentComposer value="" onValueChange={noop} onSend={noop} onAttach={noop} onStop={noop} />,
  },
  {
    prop: 'stopping',
    composer: (
      <AgentComposer value="" onValueChange={noop} onSend={noop} onAttach={noop} onStop={noop} stopping />
    ),
  },
  {
    prop: 'dictation',
    composer: <AgentComposer value="" onValueChange={noop} onSend={noop} onAttach={noop} dictation />,
  },
  {
    prop: 'sendDisabled',
    composer: <AgentComposer value="" onValueChange={noop} onSend={noop} onAttach={noop} sendDisabled />,
  },
  {
    prop: 'disabled',
    composer: <AgentComposer value="" onValueChange={noop} onSend={noop} onAttach={noop} disabled />,
  },
]

function Labeled({ value, children }: { value: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-2">
      {children}
      <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
        <span>{value}</span>
        <CopyButton
          value={value}
          className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
        />
      </div>
    </div>
  )
}

export function AgentSection() {
  const [draft, setDraft] = useState('')

  return (
    <DsSection id="agent" title="Agent">
      <Demo label="Composer" className="max-w-2xl">
        <Labeled value="<AgentComposer />">
          <AgentComposer
            value={draft}
            onValueChange={setDraft}
            onSend={() => setDraft('')}
            sendDisabled={draft.trim() === ''}
            onAttach={noop}
          />
        </Labeled>
      </Demo>
      <Demo label="Composer states" className="flex max-w-2xl flex-col gap-6">
        {STATES.map(({ prop, composer }) => (
          <Labeled key={prop} value={prop}>
            {composer}
          </Labeled>
        ))}
      </Demo>
    </DsSection>
  )
}
